import { useMutation, useQueryClient } from '@tanstack/react-query';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import request from '@teetsh/app/src/utils/request';
import { usePostHog } from 'posthog-js/react';
import { UserLocale } from '@teetsh/app/src/types/user';

export interface Signup2023RequestPayload {
  email: string;
  givenName: string;
  familyName: string;
  password: string;
  optin: boolean;
  location: string;
  locale: UserLocale;
  countryCode: string;
  parrainageToken?: string;
  edtTemplateId?: string;
  sequenceTemplateId?: string;
  programmationTemplateId?: string;
  edtTemplateDocumentId?: string;
  sequenceTemplateDocumentId?: string;
  programmationTemplateDocumentId?: string;
  shareToken?: string;
  shareEntityId?: string;
  shareEntityType?: string;
}

function signup2023(payload: Signup2023RequestPayload) {
  return request('/signup2023', {
    method: 'POST',
    body: payload,
  });
}

export default function useSignup2023() {
  const queryClient = useQueryClient();
  const posthog = usePostHog();

  const { mutateAsync } = useMutation({
    mutationFn: (payload: Signup2023RequestPayload) => signup2023(payload),

    onSuccess: () => {
      posthog.capture('Signup page completed');
      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
    },
  });
  return mutateAsync;
}
